module.exports = __webpack_public_path__ + "static/media/gift-day.e094c29d.png";